const dateMask = "%M %d, %Y %H:%i:%s";

const dateCommonFormat = webix.Date.dateToStr(dateMask);
const dateFromISO = string => new Date(string);

export { dateFromISO, dateCommonFormat };
